import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListStyle, Modal } from 'is24-corecss'

import styles from './DepositGuarantee.module.css'

type DepositGuaranteeModalProps = {
  isOpen: boolean
  onClose: () => void
}

const BENEFIT_KEYS = ['free', 'secure', 'recognized', 'protected', 'digital'] as const

export const DepositGuaranteeModal: React.FC<DepositGuaranteeModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal.Root isOpen={isOpen} onClose={onClose}>
      <Modal.Backdrop>
        <Modal.Surface width={601}>
          <Modal.Header>
            <Modal.Title>{t('wizard.screen.costs.depositGuarantee.modal.title')}</Modal.Title>
            <Modal.CloseButton aria-label={t('wizard.screen.costs.depositGuarantee.modal.close')} onClick={onClose} />
          </Modal.Header>
          <Modal.Body>
            <p className='font-body-medium-regular'>{t('wizard.screen.costs.depositGuarantee.modal.description')}</p>
            <h5 className='font-body-large-bold margin-top-xl margin-bottom-m'>
              {t('wizard.screen.costs.depositGuarantee.modal.benefitsTitle')}
            </h5>
            <ListStyle variant='checkmark' className={styles.benefitsList}>
              {BENEFIT_KEYS.map((benefit) => (
                <ListStyle.Item key={benefit}>
                  <div className='font-body-medium-bold'>
                    {t(`wizard.screen.costs.depositGuarantee.modal.benefits.${benefit}.title`)}
                  </div>
                  <div className='font-body-medium-regular'>
                    {t(`wizard.screen.costs.depositGuarantee.modal.benefits.${benefit}.description`)}
                  </div>
                </ListStyle.Item>
              ))}
            </ListStyle>
          </Modal.Body>
          <Modal.Footer>
            <Modal.PrimaryFooterButton
              label={t('wizard.screen.costs.depositGuarantee.modal.close')}
              onClick={onClose}
              variant='filledDefault'
            />
          </Modal.Footer>
        </Modal.Surface>
      </Modal.Backdrop>
    </Modal.Root>
  )
}
